export const CIPHER_SECRET_KEY = 'bx32(m3N,HZTMF]2jYo}XqrDdPVv';
export const companySeatUserID = 'PuD6KwbnJXO74QuADWMrHAYXgzt2';
const electricBillDictionaryLocal = {
  100: 'Under $100',
  200: '$100-$200',
  400: '$300-$400',
  999999999: '$400+'};
export const electricBillDictionary = electricBillDictionaryLocal;
export const electricBillOptions = Object.values(electricBillDictionaryLocal);
export const electricBillCutoffs = Object.keys(electricBillDictionaryLocal).map(num => parseInt(num, 10));
export const states = [
  { abbr: 'AL', full: 'Alabama' },
  { abbr: 'AK', full: 'Alaska' },
  { abbr: 'AZ', full: 'Arizona' },
  { abbr: 'AR', full: 'Arkansas' },
  { abbr: 'CA', full: 'California' },
  { abbr: 'CO', full: 'Colorado' },
  { abbr: 'CT', full: 'Connecticut' },
  { abbr: 'DE', full: 'Delaware' },
  { abbr: 'DC', full: 'District Of Columbia' },
  { abbr: 'FL', full: 'Florida' },
  { abbr: 'GA', full: 'Georgia' },
  { abbr: 'HI', full: 'Hawaii' },
  { abbr: 'ID', full: 'Idaho' },
  { abbr: 'IL', full: 'Illinois' },
  { abbr: 'IN', full: 'Indiana' },
  { abbr: 'IA', full: 'Iowa' },
  { abbr: 'KS', full: 'Kansas' },
  { abbr: 'KY', full: 'Kentucky' },
  { abbr: 'LA', full: 'Louisiana' },
  { abbr: 'ME', full: 'Maine' },
  { abbr: 'MD', full: 'Maryland' },
  { abbr: 'MA', full: 'Massachusetts' },
  { abbr: 'MI', full: 'Michigan' },
  { abbr: 'MN', full: 'Minnesota' },
  { abbr: 'MS', full: 'Mississippi' },
  { abbr: 'MO', full: 'Missouri' },
  { abbr: 'MT', full: 'Montana' },
  { abbr: 'NE', full: 'Nebraska' },
  { abbr: 'NV', full: 'Nevada' },
  { abbr: 'NH', full: 'New Hampshire' },
  { abbr: 'NJ', full: 'New Jersey' },
  { abbr: 'NM', full: 'New Mexico' },
  { abbr: 'NY', full: 'New York' },
  { abbr: 'NC', full: 'North Carolina' },
  { abbr: 'ND', full: 'North Dakota' },
  { abbr: 'OH', full: 'Ohio' },
  { abbr: 'OK', full: 'Oklahoma' },
  { abbr: 'OR', full: 'Oregon' },
  { abbr: 'PA', full: 'Pennsylvania' },
  { abbr: 'RI', full: 'Rhode Island' },
  { abbr: 'SC', full: 'South Carolina' },
  { abbr: 'SD', full: 'South Dakota' },
  { abbr: 'TN', full: 'Tennessee' },
  { abbr: 'TX', full: 'Texas' },
  { abbr: 'UT', full: 'Utah' },
  { abbr: 'VT', full: 'Vermont' },
  { abbr: 'VA', full: 'Virginia' },
  { abbr: 'WA', full: 'Washington' },
  { abbr: 'WV', full: 'West Virginia' },
  { abbr: 'WI', full: 'Wisconsin' },
  { abbr: 'WY', full: 'Wyoming' },
];
